import { ContentLoader } from '@frontend/design-system';
import { useScheduleReadOnlyRequestDetails } from '../../hooks/use-schedule-readonly-request-details';
import { ScheduleRequestContentWrapper } from '../types';
import { ScheduleReadOnlyRequestDetails } from './ScheduleReadOnlyRequestDetails';

export const ScheduleReadOnlyRequestModal = ({ wrapper: Wrapper }: { wrapper: ScheduleRequestContentWrapper }) => {
  const scheduleRequestDetailProps = useScheduleReadOnlyRequestDetails();
  const { scheduleRequestModalProps, isLoading, handleCloseScheduleRequestModal } = scheduleRequestDetailProps;

  return (
    <ScheduleReadOnlyRequestDetails {...scheduleRequestDetailProps}>
      <Wrapper modalProps={scheduleRequestModalProps} onClose={handleCloseScheduleRequestModal}>
        <ContentLoader show={isLoading} />
        <Wrapper.Header onClose={handleCloseScheduleRequestModal}>
          <ScheduleReadOnlyRequestDetails.Header />
        </Wrapper.Header>
        <Wrapper.Content>
          <ScheduleReadOnlyRequestDetails.Body />
          <ScheduleReadOnlyRequestDetails.Footer />
        </Wrapper.Content>
      </Wrapper>
    </ScheduleReadOnlyRequestDetails>
  );
};
